import { hasAnyRole } from '../../utils/roles';
import { ROLES } from '../../utils/roles';

const { ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_SALES_CS, ROLE_FINANCE } = ROLES;

const ALLOWED_ROLES_CREATE_PLAN = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_SALES_CS];

const ALLOWED_ROLES_VIEW_SUBSCRIPTIONS = [ROLE_OWNER, ROLE_ADMINISTRATOR, ROLE_FINANCE, ROLE_SALES_CS];

const ALLOWED_ROLES_CANCEL_SUBSCRIPTION = [ROLE_OWNER, ROLE_ADMINISTRATOR];

export function canCreatePlan(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CREATE_PLAN);
}

export function canViewSubscriptions(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_VIEW_SUBSCRIPTIONS);
}

export function canCancelSubscription(roles: string[]): boolean {
  return hasAnyRole(roles, ALLOWED_ROLES_CANCEL_SUBSCRIPTION);
}
